import { memo, lazy, Suspense } from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import SearchBoxGeneric from "components/SearchBoxGeneric";
import FilterSort from "components/FilterSort";
import { ECARDS, AI_IMAGE_PACKS } from "enums/contentTypes";
import InfiniteSearchResults from "components/SearchBoxGeneric/InfiniteSearchResults";
import SearchResults from "components/SearchResults";

import { FilterSlotWrapper, HeaderSlotWrapper } from "./styles";

const StarringYouCards = lazy(() => import("components/StarringYouCards"));
const AlgoliaSearchResultSkeleton = lazy(() => import("components/AlgoliaSearchResultSkeleton"));

const AlgoliaCards = memo(({ loading, algoliaCard, showDetails, modulePosition, initialQueryObject }) => {
  const isMosaic = AlgoliaCardsPresenter.isMosaic(algoliaCard);
  const title = AlgoliaCardsPresenter.title(algoliaCard);
  const resultsSlot = isMosaic ? InfiniteSearchResults : SearchResults;
  const searchResultsSkeletonSlot = (
    <Suspense fallback={<span />}>
      {isMosaic ? <AlgoliaSearchResultSkeleton /> : <StarringYouCards loading={loading} />}
    </Suspense>
  );
  const collectionsFilter = initialQueryObject?.configure?.facetFilters?.find((filter) =>
    filter.some((f) => f.includes("_collections:")),
  );

  const headerSlot = (
    <HeaderSlotWrapper>
      <Typography variant="h2">{title}</Typography>
    </HeaderSlotWrapper>
  );
  const filtersSlot = (
    <FilterSlotWrapper>
      <FilterSort contentTypeOptions={[ECARDS, AI_IMAGE_PACKS]} collectionsFilter={collectionsFilter} />
    </FilterSlotWrapper>
  );

  let resultsSlotProps = { showDetails, modulePosition };

  if (!isMosaic) {
    resultsSlotProps = {
      ...resultsSlotProps,
      title,
      WrappedComponent: StarringYouCards,
      shouldTrackAlgoliaAnalytics: true,
    };
  }

  return (
    <SearchBoxGeneric
      loading={loading}
      headerSlot={isMosaic ? headerSlot : null}
      filtersSlot={isMosaic ? filtersSlot : null}
      initialQueryObject={initialQueryObject}
      searchResultsSkeletonSlot={searchResultsSkeletonSlot}
      resultsSlot={resultsSlot}
      resultsSlotProps={resultsSlotProps}
    />
  );
});

AlgoliaCards.propTypes = {
  loading: PropTypes.bool,
  algoliaCard: AlgoliaCardsPresenter.shape(),
  showDetails: PropTypes.bool,
  modulePosition: PropTypes.number,
  initialQueryObject: PropTypes.shape({
    configure: PropTypes.shape({
      facetFilters: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
    }),
  }),
};

export default AlgoliaCards;
